import { useCallback } from 'react'
import { Skeleton, styled, Typography, useTheme } from '@mui/material'
import { MessageSender } from '@weblite/ts-action/message'
import { scrollToMessageByIid } from '$logic/opened-room'
import { useMessageByIid, useSenderName } from '$logic/message/react-hook'
import { MESSAGE_BG_BOX_SHADOW } from '$setup/style/constants'
import { t } from '$i18n'

const ForwardedFromPrefixTypography = styled(Typography)`
  /* @noflip */
  margin-left: 5px;
  flex-shrink: 0;
`

function RepliedToName({
  sender,
  iid,
  fromMe,
}: {
  sender: MessageSender | undefined
  iid: number | undefined
  fromMe: boolean
}) {
  const { name, loading } = useSenderName(sender as MessageSender, true)

  const onRepliedToClick = useCallback(async () => {
    if (iid) scrollToMessageByIid(iid)
  }, [iid])

  return (
    <div style={{ display: 'flex', overflow: 'hidden' }}>
      <ForwardedFromPrefixTypography
        variant="paragraph3"
        color={fromMe ? 'neutral000' : 'neutral500'}
      >
        {t('message.repliedTo')}
      </ForwardedFromPrefixTypography>

      {loading ? (
        <Skeleton
          variant="text"
          width="40px"
          height="20px"
          sx={{ display: 'inline-block', lineHeight: '20px' }}
        />
      ) : (
        <Typography
          noWrap
          color={fromMe ? 'primary300' : 'primary500'}
          variant="paragraph3"
          sx={{ cursor: 'pointer' }}
          onClick={onRepliedToClick}
        >
          {name}
        </Typography>
      )}
    </div>
  )
}

export function RepliedToInfo({
  roomId,
  repliedTo,
  fromMe,
}: {
  roomId: string
  repliedTo: number
  fromMe: boolean
}) {
  const { lightChatSenderGradient: linearBackground, neutral000 } =
    useTheme().palette || {}
  const { message: repliedToMessage } = useMessageByIid(repliedTo, roomId) || {}
  const { sender, iid } = repliedToMessage || {}
  return (
    <div
      style={{
        maxWidth: '100%',
        width: 'fit-content',
        overflow: 'hidden',
        boxSizing: 'border-box',
        /* @noflip */
        padding: '8px 10px',
        background: fromMe ? linearBackground : neutral000,
        marginBottom: '6px',
        borderRadius: '12px',
        boxShadow: MESSAGE_BG_BOX_SHADOW,
      }}
    >
      <RepliedToName
        sender={sender as MessageSender}
        iid={iid}
        fromMe={fromMe}
      />
    </div>
  )
}

RepliedToInfo.defaultProps = {}
